/**
 * Stock Chart Viewer - Configuration
 */

// Vite環境変数からAPI設定を読み込み (VITE_ プレフィックス必須)
// API Provider: 'alphavantage' or 'finnhub'
export const API_PROVIDER = import.meta.env.VITE_API_PROVIDER || 'alphavantage';
export const API_KEY = import.meta.env.VITE_API_KEY || 'demo';
export const FINNHUB_API_KEY = import.meta.env.VITE_FINNHUB_API_KEY || '';
export const USE_MOCK_DATA = import.meta.env.VITE_USE_MOCK_DATA === 'true' || import.meta.env.VITE_API_KEY === 'demo';

export const API_BASE = 'https://www.alphavantage.co/query';
export const FINNHUB_BASE = 'https://finnhub.io/api/v1';
export const TWELVE_DATA_BASE = 'https://api.twelvedata.com';

// Twelve Data API Key
export const TWELVE_DATA_API_KEY = import.meta.env.VITE_TWELVE_DATA_API_KEY || '';

export const CHART_COLORS = {
    background: '#0d1117',
    grid: '#21262d',
    text: '#c9d1d9',
    upColor: '#26a641',
    downColor: '#f85149',
    volumeUp: 'rgba(38, 166, 65, 0.5)',
    volumeDown: 'rgba(248, 81, 73, 0.5)',
};

export const PERIODS = {
    '1D': { function: 'TIME_SERIES_INTRADAY', interval: '5min', limit: 78 },
    '1W': { function: 'TIME_SERIES_INTRADAY', interval: '60min', limit: 35 },
    '1M': { function: 'TIME_SERIES_DAILY', interval: null, limit: 22 },
    '3M': { function: 'TIME_SERIES_DAILY', interval: null, limit: 66 },
    '1Y': { function: 'TIME_SERIES_DAILY', interval: null, limit: 252 },
};

export const STOCK_BASE_PRICES = {
    'AAPL': 185.00,
    'GOOGL': 175.00,
    'GOOG': 175.00,
    'MSFT': 420.00,
    'AMZN': 195.00,
    'TSLA': 250.00,
    'NVDA': 875.00,
    'META': 530.00,
    'NFLX': 610.00,
    'AMD': 175.00,
    'INTC': 48.00,
    'IBM': 210.00,
    'ORCL': 125.00,
    'CRM': 310.00,
    'CSCO': 52.00,
    'QCOM': 175.00,
    'TXN': 185.00,
    'AVGO': 1350.00,
    'ADBE': 580.00,
    'PYPL': 72.00,
};

export const COMPANY_NAMES = {
    'AAPL': 'Apple Inc.',
    'GOOGL': 'Alphabet Inc.',
    'GOOG': 'Alphabet Inc.',
    'MSFT': 'Microsoft Corporation',
    'AMZN': 'Amazon.com Inc.',
    'TSLA': 'Tesla Inc.',
    'NVDA': 'NVIDIA Corporation',
    'META': 'Meta Platforms Inc.',
    'NFLX': 'Netflix Inc.',
    'AMD': 'Advanced Micro Devices',
    'INTC': 'Intel Corporation',
    'IBM': 'IBM Corporation',
    'ORCL': 'Oracle Corporation',
    'CRM': 'Salesforce Inc.',
    'CSCO': 'Cisco Systems Inc.',
    'QCOM': 'QUALCOMM Inc.',
    'TXN': 'Texas Instruments',
    'AVGO': 'Broadcom Inc.',
    'ADBE': 'Adobe Inc.',
    'PYPL': 'PayPal Holdings Inc.',
};

export const CRYPTO_PERIODS = {
    '1D': { function: 'DIGITAL_CURRENCY_DAILY', interval: null, limit: 30 }, // Crypto daily only for now (free tier limit)
    '1W': { function: 'DIGITAL_CURRENCY_DAILY', interval: null, limit: 30 },
    '1M': { function: 'DIGITAL_CURRENCY_DAILY', interval: null, limit: 30 },
    '3M': { function: 'DIGITAL_CURRENCY_DAILY', interval: null, limit: 90 },
    '1Y': { function: 'DIGITAL_CURRENCY_DAILY', interval: null, limit: 365 },
};

export const CRYPTO_COMPANY_NAMES = {
    'BTC': 'Bitcoin',
    'ETH': 'Ethereum',
    'XRP': 'Ripple',
    'DOGE': 'Dogecoin',
    'ADA': 'Cardano',
    'SOL': 'Solana',
    'DOT': 'Polkadot',
    'LTC': 'Litecoin',
    'BCH': 'Bitcoin Cash',
    'LINK': 'Chainlink',
};

export function getCompanyName(symbol) {
    const upperSymbol = symbol.toUpperCase();
    return COMPANY_NAMES[upperSymbol] || CRYPTO_COMPANY_NAMES[upperSymbol] || upperSymbol;
}
